<template>
  <div>
    <label :class="labelClass">{{ label }}</label>
    <div class="d-flex">
      <div class="color-box clickable" :style="isValidHexColor ? { backgroundColor: internalValue } : null" @click="openColorPicker">
        <span v-if="!isValidHexColor">×</span>
      </div>
      <v-text-field v-model="internalValue" v-mask="'!#XXXXXX'" class="mb-0 ml-2" outlined dense :error-messages="error" :error="!!error" />
    </div>

    <!-- Hidden color input -->
    <input ref="colorInput" type="color" :value="internalValue || '#000000'" class="hidden-color-input" @input="updateColorFromPicker" />
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    labelClass: String,
    value: String,
    error: String,
  },
  data: () => ({
    lazyValue: '',
  }),
  computed: {
    internalValue: {
      get() {
        return this.lazyValue
      },
      set(val) {
        this.lazyValue = val
        this.$emit('input', this.lazyValue)
      },
    },
    isValidHexColor() {
      return /^#[0-9A-F]{6}$/i.test(this.internalValue)
    },
  },
  watch: {
    value(val) {
      this.lazyValue = val
    },
  },
  mounted() {
    this.lazyValue = this.value
  },

  methods: {
    openColorPicker() {
      this.$refs.colorInput.click()
    },
    updateColorFromPicker(event) {
      this.internalValue = event.target.value
    },
  },
}
</script>

<style lang="scss">
.color-box {
  width: 36px;
  height: 36px;
  border: 1px solid $cinza-d10;
  border-radius: 4px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &.clickable {
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      border-color: #1976d2;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  }

  span {
    color: $cinza-d10;
    font-weight: bold;
    font-size: 16px;
  }
}

.hidden-color-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}
</style>
